import { render, staticRenderFns } from "./InfaqAnggota.vue?vue&type=template&id=2162bea4"
import script from "./InfaqAnggota.vue?vue&type=script&lang=js"
export * from "./InfaqAnggota.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports